<template>
  <el-col
    v-if="inRow"
    :xs="24"
    :sm="12"
    :md="6"
    class="service-row-item">
    <article class="service-article">
      <header class="service-header">
        <slot name="header"/>
      </header>
      <main>
        <slot />
      </main>
    </article>
  </el-col>

  <article
    v-else
    class="service-article">
    <header class="service-header">
      <slot name="header"/>
    </header>
    <main>
      <slot />
    </main>
  </article>
</template>

<script>
export default {
  name: 'Service',

  /**
     * The properties that the component accepts.
     */
  props: {
    inRow: {
      default: true,
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      activeNames: [],
    };
  },
};
</script>
